"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _copyToClipboard = _interopRequireDefault(require("copy-to-clipboard"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
var _link = _interopRequireDefault(require("cccisd-icons/link"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _warning = _interopRequireDefault(require("cccisd-icons/warning2"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdTable = _interopRequireDefault(require("cccisd-table"));
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _BulkThumbnailForm = _interopRequireDefault(require("./BulkThumbnailForm"));
var _EditResourceForm = _interopRequireDefault(require("./EditResourceForm"));
var _ResourceForm = _interopRequireDefault(require("./ResourceForm"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd.boilerplate;

// we use the metadata field in a resource to store data particular to that resource's type
/*
  i.e. type = Video
          metadata: {embed: <iframe>, runtime: 1:23:45}
*/
function getInitialValues(resource) {
  var initialValues = {};
  switch (resource.type) {
    case 'course':
      initialValues = {
        courseCustomUrl: resource.metadata.courseCustomUrl || '',
        deploymentId: resource.metadata.deploymentId || '',
        showCreditHours: resource.metadata.showCreditHours || false,
        showCourseSectionHeaders: resource.metadata.showCourseSectionHeaders || false,
        showMainIntroduction: resource.metadata.showMainIntroduction || false,
        showMoreInfoButton: resource.metadata.showMoreInfoButton || false,
        moreInfoButtonTitle: resource.metadata.moreInfoButtonTitle || '',
        moreInfoButtonContent: resource.metadata.moreInfoButtonContent || ''
      };
      break;
    case 'document':
      initialValues = {
        fileUpload: resource.fileUpload
      };
      break;
    case 'link':
      initialValues = {
        link: resource.metadata.link
      };
      break;
    case 'product':
      initialValues = {
        product: resource.product,
        link: resource.metadata.link,
        learnMore: resource.metadata.learnMore,
        hasLicense: !!resource.product,
        cost: resource.metadata.cost,
        isExternal: resource.metadata.isExternal
      };
      break;
    case 'survey':
      initialValues = {
        surveyInfo: resource.metadata.surveyInfo || '',
        useSurveyTitle: resource.metadata.useSurveyTitle || false,
        duration: resource.metadata.duration,
        surveyType: resource.metadata.surveyType,
        audience: resource.metadata.audience,
        showLanguage: resource.metadata.showLanguage || false,
        infoResource: resource.metadata.infoResource,
        previewText: resource.metadata.previewText || '',
        showConfirmation: resource.metadata.showConfirmation || false
      };
      break;
    case 'video':
      initialValues = {
        embed: resource.metadata.embed,
        runtime: resource.metadata.runtime
      };
      break;
    default:
  }
  var commonInitialValues = _objectSpread(_objectSpread({}, resource), {}, {
    imageStyle: resource.metadata && resource.metadata.imageStyle || 'cover',
    searchTerms: resource.searchTerms || ''
  });
  return _objectSpread(_objectSpread({}, commonInitialValues), initialValues);
}
var Resources = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Resources() {
    var _this;
    _classCallCheck(this, Resources);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Resources, [].concat(args));
    _defineProperty(_this, "state", {
      loading: true,
      resources: null,
      defaultTypes: null,
      selectedRows: [],
      persistSelectedRows: []
    });
    _defineProperty(_this, "bulkIconModalRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "getDefaultThumbnails", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response, defaultTypes;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _cccisdAxios["default"].get(Boilerplate.route('api.resources.thumbnail.defaults'));
          case 2:
            response = _context.sent;
            defaultTypes = response.data.data;
            _this.setState({
              defaultTypes: defaultTypes
            });
            _this.getData();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "componentDidMount", function () {
      _this.getDefaultThumbnails();
    });
    // get all resources and store them in a reduxForm-friendly way
    _defineProperty(_this, "getData", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var params, response, resources;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            params = {
              published: 'both'
            };
            _context2.next = 3;
            return _cccisdAxios["default"].get(Boilerplate.route('api.resources.resource.index'), {
              params: params
            });
          case 3:
            response = _context2.sent;
            resources = response.data.data.map(function (item) {
              var metadata = JSON.parse(item.draft_metadata !== null && item.draft_metadata.length > 0 ? item.draft_metadata : item.published_metadata);
              var url = item.url;
              if (!url && item.type === 'link') {
                url = metadata.link;
              } else if (!url && item.type === 'video') {
                var template = document.createElement('template');
                template.innerHTML = metadata.embed.trim();
                url = template.content.firstChild.getAttribute('src');
              } else if (item.type === 'document' && url && item.published_label) {
                // Do not include file extension here. Cloudfront function will add it automatically
                url = url + '?filename=' + item.published_label;
              }
              return {
                id: item.id,
                thumbnail: {
                  id: item.draft_thumbnail_id ? item.draft_thumbnail_id : item.published_thumbnail_id,
                  small: item.small,
                  large: item.large
                },
                tags: Object.keys(item.tags || {}).map(function (n) {
                  return parseInt(n, 10);
                }),
                tagObjects: item.tags || {},
                title: item.draft_label,
                type: item.type,
                internalName: item.handle,
                description: item.draft_description ? item.draft_description : item.published_description,
                metadata: metadata,
                searchTerms: item.search_terms,
                published: !!item.is_published,
                updated: item.updated_at,
                edited: item.is_edited,
                fileUpload: {
                  name: item.filename
                },
                url: url,
                product: item.product_id,
                share_url: item.share_url
              };
            });
            _this.setState({
              loading: false,
              resources: resources
            });
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    _defineProperty(_this, "setSelectedRows", function (selectedRows) {
      if (selectedRows.length !== _this.state.selectedRows.length) {
        _this.setState({
          selectedRows: selectedRows
        });
      }
    });
    _defineProperty(_this, "togglePublished", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(id, isPublished) {
        var params;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              params = {
                publish: !isPublished
              };
              _context3.next = 3;
              return _cccisdAxios["default"].put(Boilerplate.route('api.resources.resource.update', {
                resource: id
              }), params);
            case 3:
              _this.getData();
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "deleteResource", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(id) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _cccisdAxios["default"]["delete"](Boilerplate.route('api.resources.resource.destroy', {
                resource: id
              }));
            case 2:
              _this.getData();
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }());
    return _this;
  }
  _inherits(Resources, _React$Component);
  return _createClass(Resources, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var ref = this;
      var _this$state = this.state,
        resources = _this$state.resources,
        defaultTypes = _this$state.defaultTypes,
        persistSelectedRows = _this$state.persistSelectedRows,
        selectedRows = _this$state.selectedRows;
      var columns = [{
        name: 'actions',
        label: 'Actions',
        render: function render(value, row) {
          return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
            trigger: /*#__PURE__*/_react["default"].createElement("button", {
              type: "button",
              className: "btn btn-success btn-xs"
            }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
              title: "Edit",
              placement: "top"
            }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null))),
            title: "Edit resource \"".concat(row.title, "\"")
          }, /*#__PURE__*/_react["default"].createElement(_EditResourceForm["default"], {
            getData: _this2.getData,
            initialValues: getInitialValues(row)
          })), ' ', /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-danger btn-xs",
            onClick: function onClick() {
              (0, _cccisdConfirm["default"])({
                message: 'Are you sure?',
                description: 'You are about to delete a resource!'
              }).then(function () {
                _this2.deleteResource(row.id);
                (0, _cccisdNotification["default"])({
                  message: 'Resource deleted.',
                  type: 'success'
                });
              });
            }
          }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: "Delete",
            placement: "top"
          }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null))), ' ', (row.url || row.share_url) && /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-warning btn-xs",
            onClick: function onClick() {
              var url = row.share_url || row.url;
              var isSuccess = (0, _copyToClipboard["default"])(url);
              (0, _cccisdNotification["default"])({
                message: isSuccess ? 'Copied URL to clipboard' : 'Could not copy URL to clipboard.',
                type: isSuccess ? 'success' : 'danger'
              });
            }
          }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: "Copy URL",
            placement: "top"
          }, /*#__PURE__*/_react["default"].createElement(_link["default"], null))));
        },
        "class": _style["default"].actions
      }, {
        name: 'id',
        label: 'ID',
        sort: true,
        filter: false
      }, {
        name: 'type',
        label: 'Type',
        sort: true,
        filter: true
      }, {
        name: 'thumbnail',
        label: 'Thumbnail',
        render: function render(value, row, callbacks) {
          var thumb = defaultTypes.find(function (item) {
            return item.handle === row.type;
          });
          var thumbnail = thumb.file && thumb.file.thumbnail;
          if ((!row || !row.thumbnail || !row.thumbnail.small) && !thumbnail) {
            return null;
          }
          return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
            trigger: /*#__PURE__*/_react["default"].createElement("img", {
              width: "50px",
              className: _style["default"].thumbnail + ' center-block',
              src: row.thumbnail.small ? row.thumbnail.small : thumbnail.small_url,
              alt: ""
            }),
            title: 'Thumbnail for "' + row.title + '"'
          }, /*#__PURE__*/_react["default"].createElement("img", {
            className: "center-block",
            src: row.thumbnail.large ? row.thumbnail.large : thumbnail.large_url,
            alt: ""
          }));
        }
      }, {
        name: 'title',
        label: 'Resource Title',
        sort: true,
        filter: true,
        render: function render(value, row, callbacks) {
          var _row$metadata, _row$metadata$surveyI;
          switch (row.type) {
            case 'course':
              return row.title;
            case 'product':
              {
                if (!row.product) {
                  return /*#__PURE__*/_react["default"].createElement("a", {
                    href: row.metadata.link,
                    target: "_BLANK",
                    rel: "noopener noreferrer"
                  }, row.title);
                }
                return row.title;
              }
            case 'document':
              return /*#__PURE__*/_react["default"].createElement("a", {
                href: row.url,
                target: "_BLANK",
                rel: "noopener noreferrer"
              }, row.title);
            case 'link':
              return /*#__PURE__*/_react["default"].createElement("a", {
                href: row.metadata.link,
                target: "_BLANK",
                rel: "noopener noreferrer"
              }, row.title);
            case 'survey':
              return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, row.title), ((_row$metadata = row.metadata) === null || _row$metadata === void 0 ? void 0 : (_row$metadata$surveyI = _row$metadata.surveyInfo) === null || _row$metadata$surveyI === void 0 ? void 0 : _row$metadata$surveyI.surveyLabel) && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
                style: {
                  fontSize: 'small',
                  fontWeight: '300'
                }
              }, "Survey title:"), /*#__PURE__*/_react["default"].createElement("span", null, row.metadata.surveyInfo.surveyLabel)));
            case 'video':
              return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
                trigger: /*#__PURE__*/_react["default"].createElement("a", null, row.title),
                title: ""
              }, /*#__PURE__*/_react["default"].createElement("div", {
                dangerouslySetInnerHTML: {
                  __html: row.metadata.embed
                }
              }));
            default:
          }
        }
      }, {
        name: 'internalName',
        label: 'Internal Name',
        sort: true,
        filter: true
      }, {
        name: 'tags',
        label: 'Tags',
        filter: true,
        filterSettings: {
          type: 'text',
          custom: function custom(row, value) {
            return Object.values(row.tagObjects).some(function (tag) {
              return tag.toLowerCase().includes(value.toLowerCase());
            });
          }
        },
        render: function render(value, row, callbacks) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].tagField
          }, Object.keys(row.tagObjects).map(function (k, i) {
            return /*#__PURE__*/_react["default"].createElement("span", {
              key: row.tagObjects[k],
              className: _style["default"].tags
            }, row.tagObjects[k]);
          }));
        }
      }, {
        name: 'updated',
        label: 'Last Edited',
        "class": 'text-center'
      }, {
        name: 'published',
        label: 'Published',
        sort: true,
        render: function render(value, row, callbacks) {
          var warn = null;
          if (row.edited && row.published) {
            warn = /*#__PURE__*/_react["default"].createElement("div", {
              className: "text-danger",
              style: {
                marginRight: '1em'
              }
            }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
              title: "This resource has unpublished changes. Edit the resource with the 'Publish on save' toggle on in order to publish these changes.",
              placement: "top"
            }, /*#__PURE__*/_react["default"].createElement(_warning["default"], null)));
          }
          return /*#__PURE__*/_react["default"].createElement("div", {
            "data-toggle": row.published,
            style: {
              display: 'flex',
              justifyContent: 'center'
            }
          }, warn, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
            value: row.published,
            onChange: function onChange() {
              return ref.togglePublished(row.id, row.published);
            }
          }));
        }
      }];
      var rowActions = [{
        name: "Change Thumbnails",
        isConfirm: false,
        buttonText: "Change Thumbnails",
        action: function action(data) {
          var resourceIdMapping = resources.reduce(function (total, curr) {
            total[curr.id] = curr.title;
            return total;
          }, {});
          var persisted = data.map(function (id) {
            return {
              id: id,
              title: resourceIdMapping[id]
            };
          });

          // when this function finishes, rows are automatically unselected,
          // so we need persistSelectedRows to hold it in state
          _this2.setState({
            persistSelectedRows: persisted
          }, function () {
            if (_this2.bulkIconModalRef && _this2.bulkIconModalRef.current) {
              _this2.bulkIconModalRef.current.open();
            }
          });
        }
      }];
      if (this.state.loading) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true
        });
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h2", null, "Resources"), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: 'btn btn-primary ' + _style["default"].addBtn
        }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null), " Add Resource"),
        title: "Create New Resource"
      }, /*#__PURE__*/_react["default"].createElement(_ResourceForm["default"], {
        getData: this.getData
      })), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        ref: this.bulkIconModalRef,
        render: function render(_ref5) {
          var closeModal = _ref5.closeModal;
          return /*#__PURE__*/_react["default"].createElement(_BulkThumbnailForm["default"], {
            selectedRows: persistSelectedRows,
            closeModal: closeModal
          });
        },
        title: "Change ".concat(persistSelectedRows.length, " Thumbnails"),
        afterClose: this.getData
      }), /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
        className: "table table-striped table-bordered",
        columns: columns,
        data: resources,
        isAscentOrder: false,
        orderBy: "id",
        isCsvDownload: false,
        selectedRows: selectedRows,
        rowSelectedCallback: this.setSelectedRows,
        rowActions: rowActions
      }));
    }
  }]);
}(_react["default"].Component);